import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Dashboard from "./components/Dashboard";
import Login from "./components/Login";
import NuevoCliente from "./components/NuevoCliente";
import NuevoProveedor from "./components/NuevoProveedor";
import CancelacionDocumentos from "./components/CancelacionDocumentos";
import Sudameris from "./components/PagoSudameris";
import PagoAtlas from "./components/PagoAtlas";
import GestionInmobiliariaCotizaciones from "./components/GestionInmobiliariaCotizaciones";
import GestionInmobiliariaContratos from "./components/GestionInmobiliariaContratos";
import GestionInmobiliariaCotizacionDetalle from "./components/GestionInmobiliariaCotizacionDetalle";
import GestionInmobiliariaNuevaCotizacion from "./components/GestionInmobiliariaNuevaCotizacion";
import GestionInmobiliariaContratoDetalle from "./components/GestionInmobiliariaContratoDetalle";
import InmobiliariaConfiguracion from "./components/InmobiliariaConfiguracion";
import RecordatoriosConfiguracion from "./components/RecordatoriosConfiguracion";
import RecordatoriosControl from "./components/RecordatoriosControl";
import RecordatoriosClientes from "./components/RecordatoriosClientes";
import TipoCambio from "./components/TipoCambio";
import TipoCambioBanner from "./components/TipoCambioBanner";
import RegistrarCobro from "./components/RegistrarCobro";
import PrivateRoute from "./components/PrivateRoute";


const ListaClientes = () => <h2>Lista de Clientes</h2>;
const Documentos = () => <h2>Documentos de Marketing</h2>;

const App = () => {
    const [loggedIn, setLoggedIn] = useState(false);
    const [checkingAuth, setCheckingAuth] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("sapToken");
        if (token) {
            setLoggedIn(true);
        }
        setCheckingAuth(false);
    }, []);

    // Control de expiración automática de sesión
    useEffect(() => {
        const interval = setInterval(() => {
            const userData = JSON.parse(localStorage.getItem("sapUser"));
            if (userData && userData.ExpiresAt) {
                const now = new Date();
                const expiresAt = new Date(userData.ExpiresAt);
                if (now >= expiresAt) {
                    console.warn("Sesión expirada. Cerrando sesión automáticamente...");
                    handleLogout(); // Llama a tu función para cerrar sesión
                    window.location.href = "/login"; // Redirige al login
                }
            }
        }, 60000); // cada 1 minuto

        return () => clearInterval(interval);
    }, []);

    const handleLogout = () => {
        localStorage.removeItem("sapToken");
        localStorage.removeItem("sapUser");
        setLoggedIn(false);
    };

    if (checkingAuth) return <div className="text-center mt-5">Verificando sesión...</div>;

    return (
        <Router>
            {loggedIn && <Navbar handleLogout={handleLogout} />}
            {loggedIn && <TipoCambioBanner />}
            <div className="container mt-4">
                <Routes>
                    <Route path="/" element={<Navigate to={loggedIn ? "/dashboard" : "/login"} replace />} />
                    <Route path="/login" element={loggedIn ? <Navigate to="/dashboard" replace /> : <Login setLoggedIn={setLoggedIn} />} />

                    {/* Rutas protegidas con PrivateRoute */}
                    <Route path="/dashboard" element={<PrivateRoute loggedIn={loggedIn}><Dashboard /></PrivateRoute>} />
                    <Route path="/clientes/nuevo" element={<PrivateRoute loggedIn={loggedIn}><NuevoCliente /></PrivateRoute>} />
                    <Route path="/proveedores/nuevo" element={<PrivateRoute loggedIn={loggedIn}><NuevoProveedor /></PrivateRoute>} />
                    <Route path="/clientes/lista" element={<PrivateRoute loggedIn={loggedIn}><ListaClientes /></PrivateRoute>} />
                    <Route path="/documentos" element={<PrivateRoute loggedIn={loggedIn}><Documentos /></PrivateRoute>} />
                    <Route path="/ventas/cancelacion-documentos" element={<PrivateRoute loggedIn={loggedIn}><CancelacionDocumentos /></PrivateRoute>} />
                    <Route path="/bancos/pagos/sudameris" element={<PrivateRoute loggedIn={loggedIn}><Sudameris /></PrivateRoute>} />
                    <Route path="/bancos/pagos/atlas" element={<PrivateRoute loggedIn={loggedIn}><PagoAtlas /></PrivateRoute>} />
                    <Route path="/inmobiliaria/cotizaciones" element={<PrivateRoute loggedIn={loggedIn}><GestionInmobiliariaCotizaciones /></PrivateRoute>} />
                    <Route path="/inmobiliaria/cotizaciones/nueva" element={<PrivateRoute loggedIn={loggedIn}><GestionInmobiliariaNuevaCotizacion /></PrivateRoute>} />
                    <Route path="/inmobiliaria/cotizaciones/:docEntry" element={<PrivateRoute loggedIn={loggedIn}><GestionInmobiliariaCotizacionDetalle /></PrivateRoute>} />
                    <Route path="/inmobiliaria/contratos" element={<PrivateRoute loggedIn={loggedIn}><GestionInmobiliariaContratos /></PrivateRoute>} />
                    <Route path="/inmobiliaria/contratos/:docEntry" element={<PrivateRoute loggedIn={loggedIn}><GestionInmobiliariaContratoDetalle /></PrivateRoute>} />
                    <Route path="/inmobiliaria/configuracion" element={<PrivateRoute loggedIn={loggedIn}><InmobiliariaConfiguracion /></PrivateRoute>} />
                    <Route path="/inmobiliaria/cobros" element={<PrivateRoute loggedIn={loggedIn}><RegistrarCobro /></PrivateRoute>} />
                    <Route path="/recordatorios/configuracion" element={<PrivateRoute loggedIn={loggedIn}><RecordatoriosConfiguracion /></PrivateRoute>} />
                    <Route path="/recordatorios/control" element={<PrivateRoute loggedIn={loggedIn}><RecordatoriosControl /></PrivateRoute>} />
                    <Route path="/recordatorios/clientes" element={<PrivateRoute loggedIn={loggedIn}><RecordatoriosClientes /></PrivateRoute>} />
                    <Route path="/tipo-cambio" element={<PrivateRoute loggedIn={loggedIn}><TipoCambio /></PrivateRoute>} />

                    {/* Catch-all: si no hay match, redirige */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </div>
        </Router>
    );
};

export default App;
